import React from 'react'
import {fetchAdminDocs} from 'state/actions'
import {connect} from 'react-redux'
import OfficeAdminDom from 'elements/OfficeAdminDom'

@connect(
	state => ({
		documents: state.adminDocs[state.app.brNr],
		brokerNumber: state.app.brNr,
	}),
	{fetchAdminDocs}
)
class AdminDocs extends React.Component {
	static propTypes = {
		documents: React.PropTypes.array,
		brokerNumber: React.PropTypes.string.isRequired,
		fetchAdminDocs: React.PropTypes.func.isRequired,
	}

	update() {
		const {documents, brokerNumber, fetchAdminDocs} = this.props
		if (!documents) {
			fetchAdminDocs(brokerNumber)
		}
	}

	componentDidMount() {this.update()}
	componentDidUpdate() {this.update()}

	render() {
		const {documents} = this.props
		return (
			<OfficeAdminDom>
				{documents}
			</OfficeAdminDom>
		)
	}
}

export default AdminDocs



// WEBPACK FOOTER //
// ./components/office/AdminDocs.jsx